export class ValidationResult {
	message: string;
}

export class OfferValidationResults {
	errors: Array<ValidationResult> = [];
	warnings: Array<ValidationResult> = [];
}